(function () {
  const host = window.location.hostname.toLowerCase();
  const scriptsByDomain = {
    "empower.com": [
      {
        src: "https://cdn.cookielaw.org/consent/c4e34689-0b10-442b-ab1c-bd481a4d7451/otSDKStub.js",
        domain_script: "c4e34689-0b10-442b-ab1c-bd481a4d7451",
      },
      {
        inline: "function OptanonWrapper() { window.empOnetrustOptanon?.init(); }",
      },
    ],
  };
  const defaultScripts = [
    {
      src: "https://cdn.cookielaw.org/consent/fe302350-870f-4223-b433-a6cfc02b6096-test/OtAutoBlock.js",
    },
    {
      src: "https://cdn.cookielaw.org/consent/fe302350-870f-4223-b433-a6cfc02b6096-test/otSDKStub.js",
      domain_script: "fe302350-870f-4223-b433-a6cfc02b6096-test",
    },
    {
      inline: "function OptanonWrapper() { window.empOnetrustOptanon?.init(); }",
    },
  ];
  const scriptsToLoad = scriptsByDomain[host] || defaultScripts;
  const head = document.head;

  head.appendChild(document.createComment(` OneTrust Cookies Consent Notice start for ${host} ` ));
  scriptsToLoad.forEach((item) => {
    const script = document.createElement("script");
    if (item.src) {
      script.src = item.src;
      script.type = "text/javascript";
      script.async = false;
      if (item.domain_script) {
        script.dataset.domainScript = item.domain_script;
      }
    } else if (item.inline) {
      script.type = "text/javascript";
      script.textContent = item.inline;
    }
    document.head.appendChild(script);
  });
  head.appendChild(document.createComment(` OneTrust Cookies Consent Notice end for ${host} ` ));
})();
